import { styled } from '@mui/system'

export const Container = styled('div')`
    border-radius: 8px;
    height: 100%;
`

export const Grid = styled('div')`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
`

export const StatCard = styled('div')`
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const StatHeader = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StatTitle = styled('h4')`
    font-weight: 500;
`

export const StatValue = styled('div')`
    font-size: var(--font-size-xl);
    font-weight: 700;
`

export const StatDescription = styled('div')`
    font-size: var(--font-size-s);
    color: #6b7280;
`
